var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadedPage)?_c('div',{staticClass:"entity-progress",class:{
    'progress--issue': _vm.hasIssue,
  }},_vm._l((_vm.cashbackProgress),function(check,index){return _c('div',{key:index,staticClass:"progress-check",class:{
      'progress--with-titles': _vm.titles,
    },on:{"click":function($event){return _vm.$emit('clicked', check)}}},[(_vm.titles)?_c('span',{staticClass:"check-label"},[_vm._v(_vm._s(check.label))]):_vm._e(),_c('iconComponent',{attrs:{"symbol":check.symbol,"stroke":_vm.getIconColor(check),"fill":_vm.getIconColor(check)}}),_c('span',{staticClass:"tooltip"},[_vm._v(_vm._s(_vm.getTooltip(check)))])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }